import React from "react";
import classnames from "classnames";

export interface Props {
	className?: string;
	currentActive: number;
	children: React.ReactNode;
	multiselect?: boolean;
	onKeyDown: (evt: React.KeyboardEvent) => void;
	forwardedRef: React.RefObject<HTMLDivElement>;
	handleFocus?: () => void;
	name: string;
	handleBlur?: () => void;
}

export default function KeyboardNavigable({
	className,
	currentActive,
	children,
	onKeyDown,
	multiselect,
	forwardedRef,
	handleFocus,
	name,
	handleBlur,
}: Props) {
	return (
		<div
			onFocus={handleFocus}
			onBlur={handleBlur}
			ref={forwardedRef}
			className={classnames(
				`list-group list-group-flush ${name}-list ${
					className ? className : ""
				}`
			)}
			role="listbox"
			tabIndex={0}
			aria-activedescendant={
				currentActive !== -1
					? `${name}-list__item__${currentActive}`
					: undefined
			}
			onKeyDown={onKeyDown}
			aria-label={`${name}-list`}
			aria-multiselectable={multiselect}>
			{children}
		</div>
	);
}
